import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import axios from "axios";
import { useToast } from "../../../contexts/ToastContext";

const ModalNewMeta = ({ updateMetas, fecharModal, selectedMeta }) => {

    const { notifyError, notifySuccess } = useToast();

    const [loading, setLoading] = useState(false);

    const [usuario, setUsuario] = useState( selectedMeta ? selectedMeta.usuario_id : "" );
    const [meta, setMeta] = useState( selectedMeta ? selectedMeta.meta : 0 );

    const [usuarios, setUsuarios] = useState([]);

    const getUsers = async () => {

        try {

            const { data } = await axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetUsuarios/");
            setUsuarios(data.map(u =>
                ({ value: u.id, label: u.usuario })
            ))

        } catch (e) {

            console.error(e);

        }

    }

    useEffect(() => {

        getUsers();

    }, []);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const url = selectedMeta ? "https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/AtualizarMeta/" : "https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/NovaMeta/";

            const { data } = await axios.post(url, {
                usuario,
                meta
            }, {
                withCredentials: true
            })

            console.log(data);
            updateMetas();
            fecharModal();
            notifySuccess("META SALVA COM SUCESSO!");

        } catch (e) {
            console.error(e);
            notifyError("ERRO AO SALVAR META!");
        } finally {
            setLoading(false);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={ fecharModal } >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="USUÁRIO"
                            type="select"
                            options={usuarios}
                            obj
                            valor={usuario}
                            changeFunc={(e) => setUsuario(e.target.value)}
                        />
                        <FormComp
                            title="META"
                            type="number"
                            placeholder="DIGITE..."
                            valor={meta}
                            changeFunc={(e) => setMeta(e.target.value)}
                        />
                        <FormComp
                            type="submit"
                            valor={
                                loading ? "CARREGANDO..." : "SALVAR"
                            }
                            disabled={ loading }
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNewMeta;